import { Theme } from '@mui/material/styles'

const muiTooltip = (theme: Theme) => {
  return {
    styleOverrides: {
      tooltip: {
        backgroundColor: theme.palette.text.primary,
        fontSize: '0.75rem',
        fontWeight: '400',
        borderRadius: 8,
        lineHeight: 1.5,
        padding: '0.5rem',
        border: 'none',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.2)',
        color: theme.palette.primary.contrastText,
        maxWidth: 270
      },
      arrow: {
        color: theme.palette.text.primary
      }
    }
  }
}

export default muiTooltip
